export const selectOne = (state) => state.notification
